<template>
  <div class="right-kefu-comm"></div>
</template>

<script>
import { getUnionCustomService } from "../../api";

export default {
  components: {},
  name: "right-kefu",
  data() {
    return {};
  },
  mounted() {
    this.handlerLoadKefu();
  },
  methods: {
    handlerLoadKefu() {
      getUnionCustomService().then((res) => {
        $("#app").append(res.data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.right-kefu {
}
</style>
